export default "__VITE_ASSET__B7dTCt09__"